import { GET_USER, REMOVE_USER } from "../actions/types";

const initialState = {};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_USER:
			return action.payload;
		case REMOVE_USER:
			return {};
		default:
			return state;
	}
};

export default reducer;
